import styled from 'styled-components';

import { Badge } from '../badge-v2';
import { ContentCard } from '../content-card';
import { IconButton } from '../icon-button';
import { Input } from '../input';
import { Label } from '../label';
import { Select } from '../select';

export const StyledQueryBuilderDrawerContent = styled.div<{ $width?: string }>`
  flex-grow: 1;
  padding: var(--sizes-80) var(--sizes-110);
  background-color: var(--color-gray-10);
  overflow-y: scroll;
  margin-bottom: var(--sizes-110);
  width: ${(props) => (props.$width ? props.$width : '100%')};
`;

export const StyledContentCard = styled(ContentCard)`
  margin-top: var(--sizes-30);
  margin-bottom: var(--sizes-70);
  background-color: var(--color-brand-primary-white);

  article {
    padding: var(--sizes-70);
  }
`;

export const StyledContentCardRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--sizes-110);
  justify-content: space-between;
  align-items: center;

  h3 {
    margin-bottom: var(--sizes-10);
  }
`;

export const HalfWidthContainer = styled.div`
  width: 50%;
`;

export const QueryBuilderContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

export const RuleGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  position: relative;
  z-index: 1;
`;

export const Condition = styled.div`
  max-width: 300px;
`;

export const AttributeRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  background: var(--color-gray-10);
  padding: 12px;
  border-radius: 6px;
  height: 67px;

  overflow-x: scroll;
  scrollbar-width: none;

  .multi-filter-select-button {
    max-width: 420px;
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
  }

  .multi-filter-select-button .MuiButton-endIcon {
    flex-shrink: 0;
  }

  .multi-filter-select-label {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const StyledSelect = styled(Select)`
  background-color: white;
  width: fit-content;
  min-width: fit-content;
`;

export const Value = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-end;
`;

type LabelContainerProps = {
  minWidth?: string;
};

export const LabelContainer = styled.div<LabelContainerProps>`
  display: inline-block;
  min-width: ${(props) => (props.minWidth ? props.minWidth : '57px')};
  height: 28px;
`;

export const BottomAlignedLabel = styled(Label)`
  vertical-align: bottom;
  display: inline-block;
`;

export const StyledInput = styled(Input)`
  max-width: 132px;
`;

export const StyledIconButton = styled(IconButton)`
  padding-left: 0;
`;

export const CombinatorBadge = styled(Badge)`
  width: 49px;
  background-color: #eadaf2;
  font: #3c0059;
`;

export const QueryActions = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 200px;
  gap: 8px;
`;

export const VerticalLine = styled.div`
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #ccc;
  z-index: -1;
`;
